import { Column, Text } from '@/components/core'
import { classNameBuilder } from '@/helpers'

interface DescriptiveFeedbackProps {
  feedbacks: string[]
  className?: string
  size?: 'sm' | 'md'
}

const DescriptiveFeedback = ({
  feedbacks,
  className,
  size = 'sm'
}: DescriptiveFeedbackProps) => {
  return (
    <Column className={classNameBuilder('space-y-5', className)}>
      <Text.Translated
        fontWeight="bold"
        size="lg"
        color="600"
        translationKey="descriptive_feedback_title"
      />
      <ol className="list-decimal space-y-5 pl-4">
        {feedbacks?.map((feedback, index) => (
          <li key={index} className={{ sm: 'text-sm', md: 'text-md' }[size]}>
            {feedback}
          </li>
        ))}
      </ol>
    </Column>
  )
}

export default DescriptiveFeedback
